import { resolveImagePath } from '@/utils/imageResolver';
import { cn } from '@/utils/cn';

interface ChooseYourPathProps {
  className?: string;
}

export function ChooseYourPath({ className }: ChooseYourPathProps) {
  const charterBgUrl = resolveImagePath('/images/charter-bg.jpg');
  const learnToFlyBgUrl = resolveImagePath('/images/learn-to-fly-bg.jpg');

  return (
    <section className={cn('section_choose-your-path', className)}>
      <div className="div_choose-your-path">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
            {/* Charter Column */}
            <div 
              className="relative min-h-[400px] md:min-h-[500px] flex flex-col justify-between p-8 md:p-12 text-white bg-cover bg-center bg-no-repeat"
              style={{ 
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${charterBgUrl})`,
              }}
            >
              <div className="text-stack_wrapper">
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
                  Charter
                </h2>
                <p className="text-base md:text-lg mb-8 leading-relaxed">
                  Whether for work or pleasure, we have the private charter options you need.
                </p>
              </div>
              <a 
                href="/charter" 
                className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3 rounded-md transition-colors duration-200 text-center max-w-fit"
              >
                Learn More
              </a>
            </div>

            {/* Learn To Fly Column */}
            <div 
              className="relative min-h-[400px] md:min-h-[500px] flex flex-col justify-between p-8 md:p-12 text-white bg-cover bg-center bg-no-repeat"
              style={{ 
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${learnToFlyBgUrl})`,
              }}
            >
              <div className="text-stack_wrapper">
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
                  Learn To Fly
                </h2>
                <p className="text-base md:text-lg mb-8 leading-relaxed">
                  As Chattanooga's highest-rated flight school, we are ready and waiting to help you start your flying journey.
                </p>
              </div>
              <a 
                href="/flight-instruction" 
                className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3 rounded-md transition-colors duration-200 text-center max-w-fit"
              >
                Learn More
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}